import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleIcon, Text } from '@eds-web/react';
import { StyledErrorContent } from '../access/AgeGated.style';

const PARENTAL_CONSENT_URL = 'https://www.epicgames.com/site/parental-consent';

export const ParentalGateView: React.FC = () => {
    const { t } = useTranslation();
    return (
        <StyledErrorContent>
            <div className="alert-icon">
                <ExclamationCircleIcon size={64} color={'warning'} />
            </div>
            <Text variant={'paragraphMD'} style={{ textAlign: 'center' }}>
                {t('epic.esport.error.parental.gate.message')}{' '}
                <a href={PARENTAL_CONSENT_URL} target="_blank" rel="noopener noreferrer">
                    {t('epic.esport.error.parental.gate.learn_more')}
                </a>
            </Text>
        </StyledErrorContent>
    );
};
